import { gql } from "apollo-angular";

export const CONSUME_ONE_TIME_TOKEN = gql`
		mutation consumeOneTimeToken($token: String!) {
			consumeOneTimeToken(token: $token) {
				Company
				Email
				IsAuthenticated
				SessionUID
				Username
				FirstName
				LastName
				FunctionalGroups
			}
				
		}
	`;
export const SIGN_OUT = gql`
	mutation signOut {
		signOut
		}
	`;

